import api from './authService';

export const billingConfigService = {
  async get() {
    try {
      const res = await api.get('/billing-config');
      return res.data;
    } catch (err) {
      throw err.response?.data || { message: 'Failed to load billing config' };
    }
  },
  async save(payload) {
    try {
      const res = await api.put('/billing-config', payload);
      return res.data;
    } catch (err) {
      throw err.response?.data || { message: 'Failed to save billing config' };
    }
  },
  async test() {
    try {
      const res = await api.post('/billing-config/test');
      return res.data;
    } catch (err) {
      throw err.response?.data || { message: 'Razorpay test failed' };
    }
  },
};
